import React, { useContext } from "react";
import { ContainerCrear } from "components/ContainerCrear";
import { TipoAbsentismoRegistro } from "./tipoAbsentismo-Registro";
import DrawerCamposPersonalizadosRegistro from "./tipoAbsentismo-Registro/DrawerCamposPersonalizadosRegistro";
import DrawerArchivoAdjuntoRegistro from "./tipoAbsentismo-Registro/DrawerArchivoAdjuntoRegistro";
import { SecurityContext } from "context/SecurityContextProvider";


const CrearTipoAbsentismoPage=()=>{
  const { getUsuarioAutenticado } = useContext(SecurityContext);
  const isSDF = getUsuarioAutenticado().empresaSeleccionada?.ruc === "20330791684" ? true : false;
  const isSDFEnergia = getUsuarioAutenticado().empresaSeleccionada?.ruc === "20512436090" ? true : false;
    return(
        <ContainerCrear
          titulo={(isSDF || isSDFEnergia) ? "Crear Tipo Movimiento":"Crear Tipo Absentismo"}
          descripcion={(isSDF || isSDFEnergia) ? "Formulario para crear los tipos de movimientos para tu organización":"Formulario para crear los tipos de absentismos para tu organización"}
          colSpan={12}
         >
           <TipoAbsentismoRegistro/>
           <DrawerCamposPersonalizadosRegistro/>
           <DrawerArchivoAdjuntoRegistro/>
        </ContainerCrear>
    )

}
export default CrearTipoAbsentismoPage;